import {Trans} from "react-i18next";
import {t} from "i18next";

const SuccessMessage = ({text}) => {
    const phoneText = t('final.contactPhone');
    const emailText = t('final.contactEmail');
    const telegramText = t('final.contactTelegramShort');

    return (
        <Trans i18nKey={`final.${text}`}
               values={{
                   telegram: telegramText,
                   email: emailText,
                   phone: phoneText
               }}
        >
            <a href={window.location.origin + '/me/events'} target="_blank"></a>
            <a href={`${t('final.contactTelegram')}`} target="_blank"></a>
            <a href={`mailto:${emailText}`}>{emailText}</a>
            <a href={`tel:${phoneText}`}>{phoneText}</a>
        </Trans>
    )
}

export default SuccessMessage;